import _regeneratorRuntime from "/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-runtime/regenerator";
import _asyncToGenerator from "/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-runtime/helpers/asyncToGenerator";
import _extends from "/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-runtime/helpers/extends";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from "vuex";
export default {
  name: "CommonHeader",

  data: function data() {
    return {
      items: [{
        name: "项目",
        name_en: 'Project',
        child: [{ name: "所有项目", name_en: 'All Project', url: "/project" }]
      }, {
        name: "关于我们", name_en: 'About us',
        child: [{ name: "公司简介", name_en: 'Commpany profile', url: "/us" }, { name: "团队介绍", name_en: 'Team Presentation', url: "/us/team" }, { name: "联系我们", name_en: 'Contact us', url: "/us/contact" }, { name: "加入我们", name_en: 'Join us', url: "/us/join" }]
      }, {
        name: "企业文化", name_en: 'Corporate culture',
        child: [{ name: "Corporate culture", url: "/culture" }]
      }, {
        name: "工程工艺", name_en: 'Engineering',
        child: []
      }, {
        name: "养护工艺", name_en: 'Curing',
        child: []
      }, { name: "园林基地", name_en: 'Gardens' }, { name: "新闻", name_en: 'News' }],
      expanding: false,
      idx: null,
      detailExpanding: false,
      listData: []
    };
  },

  computed: _extends({}, mapState(["winHeight", "top", 'lang', 'playing']), {
    listDataFil: function listDataFil() {}
  }),
  methods: {
    select: function select(index) {
      if (index === 5) {
        this.expanding = !this.expanding;
        this.detailExpanding = false;
        this.idx = null;
        this.$router.push({ path: '/garden', query: { lang: this.lang } });
      } else if (index === 2) {
        // expanding = !expanding, detailExpanding = false, idx = null
        this.expanding = !this.expanding;
        this.detailExpanding = false;
        this.idx = null;
        this.$router.push({ path: '/culture', query: { lang: this.lang } });
      } else if (index === 6) {
        this.expanding = !this.expanding;
        this.detailExpanding = false;
        this.idx = null;
        this.$router.push({ path: '/news', query: { lang: this.lang } });
      } else {
        if (this.idx === index) {
          this.idx = null;
        } else {
          this.idx = index;
          this.detailExpanding = true;
        }
      }
    },
    backToIndex: function backToIndex() {
      this.expanding = false;
      this.detailExpanding = false;
      this.idx = null;
      this.$router.push({ path: '/', query: { lang: this.lang } });
    },
    toggleLang: function toggleLang(param) {
      this.$store.state.lang = param;
      this.expanding = false;
      this.detailExpanding = false;
      this.idx = null;
      if (this.$route.query.index) {
        this.$router.push({ path: this.$route.path, query: { index: this.$route.query.index, lang: param } });
      } else {
        this.$router.push(this.$route.path + '?lang=' + param);
      }
    },
    getList: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var results, result, resulte;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.$store.dispatch("getPageIndex", { lang: this.lang });

              case 2:
                results = _context.sent;
                _context.next = 5;
                return this.$store.dispatch("getPageData", { id: "8", lang: this.lang });

              case 5:
                result = _context.sent;
                _context.next = 8;
                return this.$store.dispatch("getPageData", { id: "7", lang: this.lang });

              case 8:
                resulte = _context.sent;

                results.reverse().forEach(function (val, index) {
                  _this2.items[0].child.splice(index + 1, flag, { name: val.title, name_en: val.title, url: '/project/' + val.id });
                });
                result.reverse().forEach(function (val, index) {
                  _this2.items[4].child.splice(index, flag, { name: val.title, name_en: val.title, url: '/curing?index=' + index });
                });
                resulte.reverse().forEach(function (val, index) {
                  _this2.items[3].child.splice(index, flag, { name: val.title, name_en: val.title, url: '/engin?index=' + index });
                });

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getList() {
        return _ref.apply(this, arguments);
      }

      return getList;
    }()
  },
  created: function created() {
    this.getList();
  },
  mounted: function mounted() {
    this.$store.state.winHeight = window.innerHeight;
    var _this = this;
    window.onresize = function () {
      _this.$store.state.winHeight = window.innerHeight;
    };
  },

  watch: {
    top: function top(newValue) {
      this.expanding = newValue;
    },
    lang: function lang(newValue) {
      if (newValue) {
        this.getList(1);
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/CommonHeader.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/CommonHeader.vue
// module chunks = 15